import SceneList from "../../../components/Selector/SceneSelector"
import Button from "../../../components/Button/Button"
import { useNavigate } from "react-router-dom"
import Title from "../../../components/Title/Title"
import { useSetRecoilState } from "recoil";
import { classroomState } from "../../../stores/schoolAtoms";
import { sceneState } from "../../../stores/studioAtoms";
import { useEffect } from "react";

const SelectSceneSettingsPage = () => {
    const setClassroom = useSetRecoilState(classroomState)
    const setScene = useSetRecoilState(sceneState)
    const navigate = useNavigate()

    useEffect(() => {
        setClassroom(null)
        setScene(null)
        localStorage.setItem("currentScene", null)
    }, [])


    return (
        <>
            <div className="w-96">
                <Title label="촬영 설정 - Scene 선택" />
                <div className="mb-4 text-gray-500 text-sm">
                    시간 보정을 설정할 촬영(Scene)을 선택해주세요.
                </div>
                <SceneList isUsedOn={"settings"} fit={true} />
            </div>
        </>
    )
}

export default SelectSceneSettingsPage
